import * as React from "react";

export const UnableToAddToCart: React.FunctionComponent = () => {
  return (
    <>
      <div
        className="prod-button disabled"
        title="This product is not available for the selected delivery location"
      >
        Not Available
      </div>
      <a className="notAvailable" href="/Cart/ContinueShopping">
        Find Another Product
      </a>
    </>
  );
};
